import * as queryString from "query-string";

function useQuery(search?: string) {
  const s = search || window.location.search;

  return queryString.parse(s);
}

export default useQuery;
